import { ReferenceInput, SelectInput } from "react-admin";
import * as React from "react";
import { SourceVwUser } from "../../../Constants/Source";

const CreatedByInput = props => {
  return (
    <ReferenceInput source="createdBy" reference={SourceVwUser} link={false} label="CREATED BY" {...props}>
      <SelectInput optionText="name" optionValue="registerId" />
    </ReferenceInput>
  );
};

export default CreatedByInput;
